import { Flex } from "antd"
import { Text } from "ui/Typography"
import styles from "../index.module.css"
import PropTypes from "prop-types"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"
import { getEventColor } from "pagesV2/pro/Calendar/utils"
import { resolveBookingColors, getDefaultCalendarColor, getPrimaryCalendarTextColor } from "pagesV2/pro/Calendar/calendarColorUtils"
import { useTheme } from "context/AntdThemeContext"

const EventBlock = ({
  event,
  stackOffset,
  topPct,
  heightPct,
  stackIdx,
  eventColor,
  conflict,
  setIsBookingModalOpen,
  setSelectedBookingId
}) => {
  const { id, startLabel, endLabel, title, description, color } = event || {}
  const { theme } = useTheme()

  const handleClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(id)
  }

  const primaryTextColor = getPrimaryCalendarTextColor(theme)
  const defaultColor = getDefaultCalendarColor()
  const previewColors = resolveBookingColors(color || eventColor, defaultColor, primaryTextColor, getEventColor)

  return (
    <button
      type="button"
      key={id || title + startLabel + endLabel}
      className={styles.eventBlock}
      onClick={handleClick}
      style={{
        left: `${stackOffset}px`,
        top: `${topPct}%`,
        height: `${heightPct}%`,
        zIndex: 2 + stackIdx,
        backgroundColor: previewColors.backgroundColor,
        borderColor: previewColors.borderColor
      }}
    >
      <Flex vertical className={styles.eventFlexRow}>
        <Flex align="center" justify="space-between" className={styles.eventFlexRow}>
          <Text strong className={styles.eventTime} color={previewColors.textColor || primaryTextColor}>
            {startLabel} – {endLabel}
          </Text>
          {conflict ? <BookingConflictWarning /> : null}
        </Flex>
        <Text className={styles.eventTitle} color={previewColors.textColor || primaryTextColor}>{title}</Text>
        {description && <Text className={styles.eventDescription} color={previewColors.textColor || primaryTextColor}>{description}</Text>}
      </Flex>
    </button>
  )
}

EventBlock.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
  }),
  stackOffset: PropTypes.number,
  topPct: PropTypes.number,
  heightPct: PropTypes.number,
  stackIdx: PropTypes.number,
  eventColor: PropTypes.string,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  conflict: PropTypes.bool
}

export default EventBlock
